import { Rule } from 'antd/es/form'

export const requiredRules: Rule[] = [
    {
        required: true,
        message: 'Заполните поле',
        whitespace: false,
        // min: 0.1,
    },
]

export const requiredDatePickerRules: Rule[] = [
    {
        required: true,
        message: 'Заполните поле',
    },
]

export const requiredInputNumberRules: Rule[] = [
    {
        required: true,
        message: 'Заполните поле',
        // min: 0.1,
    },
]

export const requiredOneElementRules: Rule[] = [
    {
        required: true,
        message: 'Выберите элемент из списка',
    },
]

export const phoneRules: Rule[] = [
    {
        pattern: /^(\+7|8)?\s*\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/,
        message: 'Введите телефон в формате +7 999 999-99-99',
    },
]

export const timeRangeRules: Rule[] = [
    {
        pattern: /^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/,
        message: 'Введите время в формате 09:00-18:00',
    },
]
